import { render, staticRenderFns } from "./WpsDialog.vue?vue&type=template&id=5c1021dc"
import script from "./WpsDialog.vue?vue&type=script&lang=js"
export * from "./WpsDialog.vue?vue&type=script&lang=js"
import style0 from "./WpsDialog.vue?vue&type=style&index=0&id=5c1021dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports